export default "{\n    \"label\": \"Customer Review\",\n    \"options\": {\n        \"false\": \"Bad Review\",\n        \"true\": \"Good Review\"\n    }\n}\n"